export enum LocalStorageKeys {
  // CONFIGURATION
  B2C_CONFIGURATION = "B2C_CONFIGURATION",
  AUTHENTICATION_PARAMETERS = "AUTHENTICATION_PARAMETERS",
  BLOB_STORAGE = "blobStorage",
  LOADED = "LOADED",

  // LOCALIZATION
  LANG = "LANG",
  SOCIETEG = "SOCIETEG",

  // TUTORIALS
  SIDEBAR_SHOWED = "SIDEBAR_SHOWED",

  // MARKETLEADER
  SELECTED_SUPPLIER = "SELECTED_SUPPLIER",

  // PRODUCT_LIST
  SHOW_IMAGES = "SHOW_IMAGES",
  PAGE_SIZE_ = "PAGE_SIZE_",
  SELECTED_PAGE_ = "SELECTED_PAGE_",

  // FIELD_DATA_STORAGE
  FIELD_NAME_LIST = "FIELD_NAME_LIST",
  FIELD_DATA_PREFIX = "FIELD_",
}

export enum LocalStorageColumnsKeys {
  SUPPLIER_REF = "supplierRef",
  LABEL = "label",
  COM_TREE = "comTree",
  PRICE = "price",
  EAN = "ean",
  MANUFACTURER_REF = "manufacturerRef",
  DATE_CREAT = "dateCreat",
  DATE_MAJ = "dateModif",
  REF_VENTE = "refVente",
}

const fieldNameSeparator = ";"

export const storeFieldDataInLS = (fieldName: string, fieldData: any) => {
  const field = LocalStorageKeys.FIELD_DATA_PREFIX + fieldName
  const data = JSON.stringify(fieldData)

  localStorage.setItem(field, data)

  const storedFields = localStorage.getItem(LocalStorageKeys.FIELD_NAME_LIST)

  if (!storedFields) {
    localStorage.setItem(LocalStorageKeys.FIELD_NAME_LIST, fieldName)
  } else if (!storedFields.includes(fieldName)) {
    localStorage.setItem(
      LocalStorageKeys.FIELD_NAME_LIST,
      storedFields + fieldNameSeparator + fieldName
    )
  }
}

export const getFieldDataFromLS = (
  fieldName: string,
  defaultValue: any = ""
) => {
  const field = LocalStorageKeys.FIELD_DATA_PREFIX + fieldName

  const result = localStorage.getItem(field)

  return (result && JSON.parse(result)) || defaultValue
}

export const purgeFieldDataFromLS = () => {
  const storedFields = localStorage.getItem(LocalStorageKeys.FIELD_NAME_LIST)

  if (!storedFields) {
    return
  } else {
    const fieldList: string[] = storedFields.split(fieldNameSeparator)
    fieldList.forEach((f) => {
      const field = LocalStorageKeys.FIELD_DATA_PREFIX + f
      localStorage.removeItem(field)
    })

    localStorage.removeItem(LocalStorageKeys.FIELD_NAME_LIST)
  }
}

export const getCurrentPage = (supplierName: string, defaultValue = 0) => {
  const cP = window.localStorage.getItem(
    LocalStorageKeys.SELECTED_PAGE_ + supplierName
  )
  return parseInt(cP || "", 10) || defaultValue
}

export const getPageSize = (supplierName: string, defaultValue = 10) => {
  const pS = window.localStorage.getItem(
    LocalStorageKeys.PAGE_SIZE_ + supplierName
  )
  return parseInt(pS || "", 10) || defaultValue
}
